import { useMemo, useState } from "react";
import { useTable } from "react-table";
import { defaultDateDisplay, formatCurrency } from "../../../../helpers";
import primaryComponents from "../../../primaryComponents";
import { Link, useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../routes/pathContants";
import { DeleteIcon } from "../../../../assets/svgIcons";
import "../../../../assets/styles/base/globalPage.scss";
import { GRExtra } from "../GRExtra";
import secondaryComponents from "../..";

export const useGRNTable = ({ goodsReceived }) => {
  const navigate = useNavigate();
  const [selectedGRDetails, setSelectedGRDetails] = useState(null);

  const columns = useMemo(
    () => [
      {
        Header: "Created At",
        accessor: "created_at",
        Cell: ({ cell: { value } }) =>
          value ? defaultDateDisplay(value) : "N/A",
      },
      {
        Header: "GRN Number",
        accessor: "gr_number",
        Cell: ({ cell: { value }, row }) => (
          <Link
            to={pathConstants.INVENTORY_GOODS_RECEIVED_DETAILS({
              id: row?.original?.id,
            })}
            className="purple--text smallest-text-size"
          >
            {value || "N/A"}
          </Link>
        ),
      },
      {
        Header: "PO Number",
        accessor: "purchase_order",
        Cell: ({ cell: { value }, row }) => (
          <Link
            to={pathConstants.INVENTORY_PURCHASE_ORDER_DETAILS({
              id: value?.id,
            })}
            className="purple--text smallest-text-size"
          >
            {value?.po_number || "N/A"}
          </Link>
        ),
      },
      {
        Header: "Supplier",
        accessor: "supplier",
        Cell: ({ cell: { value } }) => (
          <Link
            to={pathConstants.INVENTORY_SUPPLIERS_DETAILS({
              id: value?.id,
            })}
            className="purple--text smallest-text-size"
          >
            {value?.name || "N/A"}
          </Link>
        ),
      },
      {
        Header: "Store",
        accessor: "stores",
        Cell: ({ cell: { value } }) =>
          value?.map((store) => store?.name)?.join(", ") || "N/A",
      },
      {
        Header: "Total Amount",
        accessor: "total_item_amount",
        Cell: ({ cell: { value }, row }) =>
          formatCurrency({
            value: value,
            currencyCode: row?.original?.stores?.[0]?.currency_code,
          }),
      },

      {
        Header: "Actions",
        accessor: "fulfillment_state",
        Cell: ({ row }) => (
          <span className="d-flex align-items-center" style={{ gap: "10px" }}>
            {row?.original?.status === "DRAFT" ? (
              <secondaryComponents.NavigateWithPermission
                permissionParentKey={"Inventory Management"}
                permissionChildKey={"can_create_or_update_goods_received"}
              >
                <primaryComponents.Button
                  className="btn btn--primary smallBtn"
                  onClick={() => {
                    navigate(
                      pathConstants.INVENTORY_GOODS_RECEIVED_EDIT({
                        id: row?.original?.id,
                      }),
                    );
                  }}
                >
                  Update PO
                </primaryComponents.Button>
              </secondaryComponents.NavigateWithPermission>
            ) : null}

            {row?.original?.status === "ACCEPTED" ||
            row?.original?.status === "REJECTED" ||
            row?.original?.status === "IN_REVIEW" ? (
              <primaryComponents.Button
                className="btn btn--primary smallBtn"
                onClick={() => {
                  navigate(
                    pathConstants.INVENTORY_GOODS_RECEIVED_DETAILS({
                      id: row?.original?.id,
                    }),
                  );
                }}
              >
                {row?.original?.status === "IN_REVIEW" ? "Review" : "View GRN"}
              </primaryComponents.Button>
            ) : null}

            {row?.original?.status !== "ACCEPTED" ? (
              <span
                className="cursor-pointer"
                onClick={() => setSelectedGRDetails(row?.original)}
              >
                <DeleteIcon />
              </span>
            ) : null}

            <GRExtra
              GRDetails={row?.original}
              btnStyles={{ width: "40px", height: "32px" }}
            />
          </span>
        ),
      },
    ],
    [],
  );

  const instance = useTable({
    columns,
    data: goodsReceived || [],
  });

  return {
    instance,
    selectedGRDetails,
    setSelectedGRDetails,
  };
};
